import { CSSProperties, MouseEvent, useState } from "react";
import { TextFieldProps } from "@material-ui/core/TextField/TextField";
import { InputAdornment, TextField } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

type Props = TextFieldProps & {};

const visibilityToggleButtonStyle: CSSProperties = {
  alignItems: "center",
  background: "transparent",
  border: 0,
  borderRadius: "50%",
  color: "inherit",
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "center",
  margin: 0,
  padding: 8,
};

export const PasswordInput = ({ InputProps, ...args }: Props) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(show => !show);

  const handleMouseDownPassword = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <TextField
      {...args}
      type={showPassword ? "text" : "password"}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <>
            {InputProps?.endAdornment}
            <InputAdornment position="end">
              <button
                type="button"
                disabled={args.disabled}
                style={visibilityToggleButtonStyle}
                tabIndex={-1}
                aria-pressed={showPassword}
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </button>
            </InputAdornment>
          </>
        ),
      }}
    />
  );
};
